import Timings from './Timings';

export default Timings;
